import {loggedGet, loggedPost} from '@/library/ajax'
import fn from '@/library/fn'

const apiUrl = process.env.VUE_APP_API_URL
const apiEventUrl = process.env.VUE_APP_API_EVENT_URL

export const getPage = (data) => loggedGet(apiUrl + '/page', data)
export const getForm = (data) => loggedGet(apiUrl + '/form', data)
export const detailForm = (formId) => loggedGet(apiUrl + '/form/' + formId, {})
export const detailPage = (pageId) => loggedGet(apiUrl + '/page/' + pageId, {})
export const getEventPages = (eventId) => loggedGet(apiEventUrl + '/event/integration/page', {eventId})

export const createComponentPayment = (data) => {
  return loggedPost(`${apiUrl}/page/${data.pageId}/row/${data.rowId}/component`, {
    colomOrder: 0,
    type: ['event'],
    order: 0
  })
}
export const editPage = (data) => {
  return loggedPost(`${apiEventUrl}/event/integration/page`, {
    eventId: data.eventId,
    pageId: data.pageId,
  })
}

const _setPaymentPage = (eventId, pageId) => {
  return new Promise((resolve, reject) => {
    detailPage(pageId)
      .then(res => {
        if (res.rowList.length < 1) return Promise.reject('page not valid')
        return editPage({
          name: res.name,
          pageId,
          eventId
        })
      })
      .then(res => {
        const input = {
          pageId,
          rowId: res.rowList[0].id
        }
        return Promise.all([input, createComponentPayment(input)])
      })
      .then(() => {
        resolve(true)
      })
      .catch(err => {
        if (typeof err === 'string') {
          fn.notyError(err)
        }
        reject(err)
      })
  })
}

export const setPaymentPage = _setPaymentPage